import React from 'react';
import { css } from '@emotion/react';
import { white } from 'styles/global_defaults/colors';
import { heatwave, dunes } from 'athena/styles/colors';
import { boldFontWeight, openSans } from 'styles/global_defaults/fonts';
import { threeQuartersSpacing } from 'styles/global_defaults/scaffolding';

const BADGE_HEIGHT = 28;

const styles = css`
  display: inline-flex;
  align-items: center;
  height: ${BADGE_HEIGHT}px;
  padding: 0 ${threeQuartersSpacing}px;
  border-radius: 100px;
  background: linear-gradient(45deg, ${dunes} 0%, ${heatwave} 100%);
  color: ${white};
  font-family: ${openSans};
  font-weight: ${boldFontWeight};
`;

type Props = {
  label: string;
  className?: string;
  dataQa?: string;
};

const TierBadge = ({ label, className, dataQa }: Props) => (
  <span css={styles} className={`text-small ${className ?? ''}`} data-qa={dataQa}>
    {label}
  </span>
);

export default TierBadge;
